import axios from "../../http/axios";
import * as actionTypes from "./actionTypes";
export const GET_FINANCE_DRIVERS = "GET_FINANCE_DRIVERS";
export const GET_FINANCE_SINGLE_DRIVER = "GET_FINANCE_SINGLE_DRIVER";
export const GET_SEARCH_FINANCE_DRIVERS = "GET_SEARCH_FINANCE_DRIVERS";
export const GET_SEARCH_SINGLE_FINANCE_DRIVERS =
  "GET_SEARCH_SINGLE_FINANCE_DRIVERS";
export const DOWNLOAD_FINANCE_DRIVERS = "DOWNLOAD_FINANCE_DRIVERS";
export const DOWNLOAD_SINGLE_FINANCE_DRIVERS =
  "DOWNLOAD_SINGLE_FINANCE_DRIVERS";

export const GET_REPORTS_FINANCE_SINGLE_DRIVER =
  "GET_REPORTS_FINANCE_SINGLE_DRIVER";

export function getFinanceDrivers(token, page) {
  const request = axios.get(`/reports-driver-finance/?page=${page}`, {
    headers: { Authorization: "JWT " + token }
  });
  return dispatch =>
    request.then(res =>
      dispatch({
        type: GET_FINANCE_DRIVERS,
        payload: res.data
      })
    );
}
export function getFinanceSingleDriver(token, id) {
  const request = axios.get(`/reports-driver-finance/${id}`, {
    headers: { Authorization: "JWT " + token }
  });
  return dispatch =>
    request.then(res =>
      dispatch({
        type: GET_FINANCE_SINGLE_DRIVER,
        payload: res.data
      })
    );
}
export function getSearchFinanceDrivers(token, value) {
  const request = axios.get(`/reports-driver-finance/?search=${value}`, {
    headers: { Authorization: "JWT " + token }
  });
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_SEARCH_FINANCE_DRIVERS,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function getReportsSingleDriverFinance(token, id, page) {
  const request = axios.get(
    `/reports/single-driver-finance/${id}/?page=${page}`,
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request.then(res =>
      dispatch({
        type: GET_REPORTS_FINANCE_SINGLE_DRIVER,
        payload: res.data
      })
    );
}
export function getSearchFinanceSingleDrivers(token, id, from, to) {
  const request = axios.get(
    `/reports/single-driver-finance/${id}/?${from ? `from_date=${from}` : ""}${
      to ? `&to_date=${to}` : ""
    }`,
    {
      headers: { Authorization: "JWT " + token }
    }
  );

  return dispatch =>
    request
      .then(res => {
        return dispatch({
          type: GET_SEARCH_SINGLE_FINANCE_DRIVERS,
          payload: res.data
        });
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function downloadFinanceSingleDriver(token, id, from, to) {
  const request = axios.get(
    `/reports/single-driver-finance/${id}/?${from ? `from_date=${from}` : ""}${
      to ? `&to_date=${to}` : ""
    }`,
    {
      headers: { Authorization: "JWT " + token, Accept: "text/csv" },
      responseType: "blob"
    }
  );
  return dispatch => {
    return request
      .then(res =>
        dispatch({
          type: DOWNLOAD_SINGLE_FINANCE_DRIVERS,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
}
export function downloadFinanceDrivers(token, from, to, value) {
  const request = axios.get(
    `/reports-driver-finance/?${value ? `&search=${value}` : ""}&show_all=true`,
    {
      headers: { Authorization: "JWT " + token, Accept: "text/csv" }
    }
  );
  return dispatch => {
    return request
      .then(res =>
        dispatch({
          type: DOWNLOAD_FINANCE_DRIVERS,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/financeDrivers.js